module.exports = __webpack_public_path__ + "img/FR14628.c3c705d0.png";